import React, { useState, useEffect } from 'react';
import api from 'api';
import Autocomplete from '../AutoComplete';

// Site autocomplete that resolves its own display label when the field value was set
// programmatically. The "New Contract for Site" action on the Site screen pushes
// site_id via location.state.pushedFormValues, so the contract create form opens with
// site_id already in the field store. The plain `autocomplete` control only derives its
// label from the loaded record (`values`), which is null on a create form, so a pushed
// site_id would otherwise render as a blank/"null" chip. When we have a value but no
// live label, fetch the site to learn its name -- mirrors the label-resolution approach
// in BillToCustomer.
//
// getFieldDecorator injects `value` (site_id) and `onChange` into this component.
function SiteAutocomplete({ value, onChange, item, values }) {
    const initialLabel = values
        ? (item.displayFunc ? item.displayFunc(values) : values[item.displayKey])
        : null;

    const [label, setLabel] = useState(initialLabel);

    useEffect(() => {
        if (!value || label) return;

        let cancelled = false;
        api.get('/sites/' + value)
            .then(resp => {
                if (cancelled) return;
                const site = (resp && resp.body) || {};
                if (site.name) setLabel(site.name);
            })
            .catch(() => {});

        return () => { cancelled = true; };
    }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Autocomplete
            value={value}
            onChange={onChange}
            valueLabel={label}
            suggestFormat={item.suggestFormat}
            suggestFields={item.suggestFields}
            suggestUrl={item.suggestUrl}
            placeholder={item.placeholder} />
    );
}

export default SiteAutocomplete;
